// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card.home-rectangle[data-v-17a2da94]{display:flex;flex-direction:column;width:250px;height:120px;margin-top:15px;background:#ee7f00;border-radius:15px;color:#fff}.v-card.home-rectangle .v-card__title[data-v-17a2da94]{padding-left:10px;padding-right:10px;word-break:break-word;font-weight:400;font-size:14.8px;line-height:21px}.v-card.home-rectangle .v-card__subtitle[data-v-17a2da94]{display:flex;flex-grow:1;justify-content:center;align-items:center;color:#fff}", ""]);
// Exports
module.exports = exports;
